/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import YearFilterCard from '../../../../common/components/YearFilterCard/YearFilterCard';
import _ from 'lodash';
import GetPayHistoryActionBox from '../../../../common/components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import PaySlipModalController from '../../../../common/Modals/Salary/PaySlipModal/PaySlipModalController';
import {
  check_user_permission,
  getAmount,
  getPreviousYears,
} from '../../../../common/configs/utils';
import moment from 'moment';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { usePermission, useTranslate } from '../../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../../../common/helper';
import { DateField } from '../../../../components';
import { useSelector } from 'react-redux';
import { useAppSelector } from '../../../../infra/hooks';

interface propsType {
  payHistoryData: any;
  setFilterYear: (data: number) => void;
  currency: any;
  isLoading?: boolean;
  trans?: any;
}

const PayHistoryPresenter: React.FC<propsType> = ({
  payHistoryData,
  setFilterYear,
  currency,
  isLoading,
  trans,
}) => {
  const { t } = useTranslation();
  const [yearTitle, setyearTitle] = useState(moment(new Date()).format('YYYY'));
  const [openPaySlip, setOpenPaySlip] = useState(false);
  const [showPayHistory, setShowPayHistory] = useState(false);
  const [paySlipData, setPaySlipData] = useState([]);

  const userCanReadSalary = usePermission('Employee Portal Show Salary');

  const handleSelectyear = (year: any) => {
    setyearTitle(year.label);
    setFilterYear(year.id);
  };

  const configMenuList = useAppSelector(
    (state: any) => state.sideMenuSlice?.conigMenu,
  );

  useEffect(() => {
    const found = configMenuList?.some(
      (item: any) => item.name?.toLowerCase() === 'Pay History'.toLowerCase(),
    );
    setShowPayHistory(found);
  }, [configMenuList]);
  const tableColumns: any = [
    {
      field: 'monthYear',
      headerName: trans('Month Year'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.monthYear} format={baseDateFormatting} />
      ),
    },
    {
      field: 'salary',
      headerName: trans('Salary'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'paymentMode',
      headerName: trans('Payment Mode'),
      width: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          userCanReadSalary && (
            <GetPayHistoryActionBox
              onView={() => {
                setOpenPaySlip(true);
                setPaySlipData(params?.row?.data);
              }}
            />
          )
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const historyData: any = _.map(payHistoryData, (data: any) => {
    const rowData: any = {
      id: data?.id,
      monthYear: data?.period?.start_date,
      paymentMode: data?.payment_mode ? trans(data?.payment_mode) : '--',
      salary: userCanReadSalary
        ? `${currency} ${getAmount(data?.net_salary)}`
        : '',
      data: data,
    };
    return rowData;
  });

  const { isRTL } = useTranslate();

  return (
    <div>
      {!showPayHistory && (
        <YearFilterCard
          card_title={trans('Pay History')}
          card_height="auto"
          onYearSelect={handleSelectyear}
          yearMenu={getPreviousYears()}
          yearTitle={yearTitle}
        >
          <Box style={{ marginBottom: '24px' }} />

          {isLoading ? (
            <Loader height={100} width={200} />
          ) : (
            <Box
              sx={{
                '& .header': {
                  backgroundColor: '#F5F5F5',
                },
              }}
            >
              <DataGrid
                sx={{
                  color: '#081735',
                  font: 'normal normal normal 14px/24px Lato;',
                }}
                autoHeight
                disableExtendRowFullWidth
                disableColumnMenu
                disableSelectionOnClick
                localeText={isRTL ? arabicDataGrid : undefined}
                rows={historyData}
                columns={tableColumns}
                componentsProps={{
                  pagination: {
                    labelRowsPerPage: t('Rows per page'),
                  },
                }}
              />
            </Box>
          )}
        </YearFilterCard>
      )}

      {/* Payslip Modal */}

      {openPaySlip && (
        <PaySlipModalController
          closeModal={() => setOpenPaySlip(false)}
          isModalOpen={openPaySlip}
          payslipData={paySlipData}
        />
      )}
    </div>
  );
};

export default PayHistoryPresenter;
